import { Controller } from "@hotwired/stimulus"

// Toggles a password input between masked/plain text. `icon` swaps between
// the eye / eye-off glyphs (both pre-rendered, visibility toggled via
// `hidden` — see UI::PasswordFieldComponent) so no icon-name JS lookup is
// needed here.
export default class extends Controller {
  static targets = ["input", "showIcon", "hideIcon"]

  toggle() {
    const willReveal = this.inputTarget.type === "password"
    this.inputTarget.type = willReveal ? "text" : "password"
    // Once revealed, show the eye-off glyph ("click to hide"); once masked
    // again, show the plain eye ("click to reveal").
    this.showIconTarget.classList.toggle("hidden", willReveal)
    this.hideIconTarget.classList.toggle("hidden", !willReveal)
  }
}
